module.exports = __webpack_public_path__ + "img/shopify.a923c1b1.png";